export default __webpack_public_path__ + "static/media/more-spin.5faf0d92.webp";